/**
 * Dev-only role simulation: the value of `demo.role` in localStorage, or `null` outside development.
 * See `useIsAdmin` for the accepted values.
 */
export function getDevRoleOverride(): string | null {
  if (!import.meta.env.DEV || typeof window === 'undefined') {
    return null;
  }

  return window.localStorage.getItem('demo.role');
}
